import { Typography, Stack, Alert, AlertTitle } from '@mui/material';
import { t } from 'i18next'
import { getCurrencyText } from "../../../shared/utils/hubstripe.js";
import { Invoice } from '../../../shared/types/invoice.type.js';
import { useEffect, useState } from 'react';
import { isEmpty } from 'lodash';

type BillingMessageProps = {
    invoices: Invoice[]
}
function BillingMessage({ invoices }: BillingMessageProps) {

    const [remainValue, setRemainValue] = useState(-1)



    useEffect(() => {
        if (isEmpty(invoices)) return
        let filteredInvoices = invoices.filter((invoice: Invoice) => { return !['draft', 'paid', 'void'].includes(invoice.status) })

        setRemainValue(filteredInvoices.reduce((accumulator: number, currentValue: Invoice) => accumulator + currentValue.amount_remaining, 0))

    }, [invoices])



    return (
        <>
            {remainValue !== -1 && (
                <div className="fixed-width">
                    <Stack spacing={2}>
                        {remainValue > 0 ?
                            <Alert variant="filled" severity="error">
                                <AlertTitle>{t("billing:warning")}</AlertTitle>
                                {t("billing:warning_message")}:
                                <p></p>
                                <Typography variant="h4" gutterBottom>
                                    {getCurrencyText(remainValue / 100, invoices[0].currency)}
                                </Typography>
                            </Alert>
                            :
                            <Alert variant="filled" severity="success" sx={{ color: 'white' }}>
                                <AlertTitle>{t("billing:success")}</AlertTitle>
                                {t("billing:success_message")}
                            </Alert>
                        }
                    </Stack>
                </div>
            )
            }
        </>
    );
}

export default BillingMessage;
